<template>
  <div class="v_space_photo_backgound">
    <div class="v_space_photo_title">
      <div class="v_space_photo_title_text">
        <span class="v_space_photo_title_name">{{
          photoAlbumDetails.name
        }}</span>
        相册
      </div>
      <img
        class="iv_close"
        src="@/assets/images/space/iv_close.png"
        alt=""
        @click="closePhoto()"
      />
    </div>
    <div class="v_space_photo_button">
      <el-button
        :style="
          updateFileList.length == 0
            ? 'width: 10rem; margin-right: 5rem; background-color: #c8c9cc; border: 0.1rem solid #c8c9cc; color: #ffffff'
            : 'width: 10rem; margin-right: 5rem; background-color: #FF4A24; border: 0.1rem solid #FF4A24; color: #ffffff'
        "
        @click="choicePhotoDelete()"
        v-if="choiceClick == 0"
        :disabled="updateFileList.length == 0"
        >删除
      </el-button>

      <el-button
        :type="updateFileList.length == 0 ? 'info' : 'primary'"
        style="width: 10rem; margin-right: 3rem; margin-left: 0rem"
        @click="choicePhotoMove()"
        v-if="choiceClick == 0"
        :disabled="updateFileList.length == 0"
        >迁移
      </el-button>

      <el-upload
        :data="OSSInfo"
        action=""
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
        :on-progress="uploadVideoProcess"
        :on-error="handleAvatarError"
        :file-list="file_list"
        :on-exceed="onEexceed"
        :http-request="myFileUpload"
        :limit="10"
        v-if="choiceClick == 0"
        multiple
        ref="upLoad"
        class="upLoadVideo_all"
        :on-change="handFileChange"
      >
        <el-button
          type="primary"
          class="upLoadVideo"
          style="width: 10rem; margin-right: 3rem"
          >上传</el-button
        >
      </el-upload>
    </div>

    <div class="v_space_photo_list_none" v-show="updateFileList.length == 0">
      还没有上传照片或视频
    </div>

    <div
      class="v_space_photo_list"
      id="scrollPhoto"
      v-show="updateFileList.length > 0"
    >
      <!-- @start="drag=true" -->

      <draggable
        class="v_draggable_area"
        v-model="updateFileList"
        :options="{
          sort:isCanDrag,
          disabled:!isCanDrag
        }"
        group="photos"
        @start="handlePhotosOrderChangeStart"
        @end="handlePhotosOrderChangeEnd"
        
      >
        <!-- <div v-for="element in myArray" :key="element.id">{{element.name}}</div> -->
        <!-- :style="i % 8 == 0 ? 'margin-left: 0rem;' : 'margin-left: 3rem;'" -->

        <div
          class="v_space_photo_list_item"
          v-for="(item, i) in updateFileList"
          :key="item.id"
          style="margin-left: 3rem;"
        >
          <div
            class="v_item_all"
            :style="
              choiceClick == 0
                ? ''
                : (choiceClick == 2 && item.adminShowDel == 0) ||
                  (choiceClick == 1 && item.isUpdate != 3)
                ? 'cursor: not-allowed;'
                : 'cursor: pointer;'
            "
            @click="toChoicePhoto(i)"
          >
            <img
              v-if="item.type == 1 && item.dmId != undefined"
              :src="
                item.photoUrl + '?x-oss-process=image/resize,m_fill,h_200,w_200'
              "
              class="update_item_img_all_img"
              :style="item.isUpdate != 3 ? '-webkit-filter: blur(0.1rem);' : ''"
            />
            <img
              v-if="item.type == 1 && item.dmId == undefined"
              :src="item.photoUrl"
              class="update_item_img_all_img"
              :style="item.isUpdate != 3 ? '-webkit-filter: blur(0.1rem);' : ''"
            />
            <img
              v-if="item.type == 2 && item.dmId != undefined"
              :src="
                item.photoUrl + '?x-oss-process=video/snapshot,t_1,m_fast,f_jpg'
              "
              class="update_item_img_all_img"
              :style="item.isUpdate != 3 ? '-webkit-filter: blur(0.1rem);' : ''"
            />
            <video
              v-if="item.type == 2 && item.dmId == undefined"
              :src="item.photoUrl"
              :controls="false"
              class="update_item_img_all_img_video"
              width="15rem"
              height="15rem"
              :style="item.isUpdate != 3 ? '-webkit-filter: blur(0.1rem);' : ''"
            />

            <div class="update_item_img_all_img_seconds" v-if="item.type == 2">
              {{ item.seconds }}
            </div>

            <div class="update_item_img_all" v-if="item.isUpdate != 3">
              <div class="update_item_img_all_gray" v-if="item.isUpdate != 3">
                <img
                  v-if="item.isUpdate == 1"
                  src="@/assets/images/space/iv_update_success.png"
                  alt=""
                  class="update_item_img_all_img_suc"
                />
                <img
                  v-if="item.isUpdate == 2"
                  src="@/assets/images/space/iv_update_failed.png"
                  alt=""
                  class="update_item_img_all_img_fai"
                  @click="toUpdateAgain(i, item)"
                />
                <img
                  v-if="item.isUpdate == 4"
                  src="@/assets/images/space/iv_update_failed_small.png"
                  alt=""
                  class="update_item_img_all_img_fai"
                />
                <img
                  v-if="item.isUpdate == 5"
                  src="@/assets/images/space/iv_update_failed_change.png"
                  alt=""
                  class="update_item_img_all_img_fai"
                />
                <img
                  v-if="item.isUpdate == 6"
                  src="@/assets/images/space/iv_update_failed_no.png"
                  alt=""
                  class="update_item_img_all_img_fai"
                />
                <img
                  v-if="item.isUpdate == 7"
                  src="@/assets/images/space/iv_update_failed_pms.png"
                  alt=""
                  class="update_item_img_all_img_fai"
                />
                <img
                  v-if="item.isUpdate == 8"
                  src="@/assets/images/space/iv_update_failed_continue.png"
                  alt=""
                  class="update_item_img_all_img_fai"
                  @click="toUpdateContinue(i, item)"
                />
                <el-progress
                  v-if="item.isUpdate == 0"
                  :percentage="item.percent"
                  :stroke-width="10"
                  color="#2C90FF"
                  class="video_progress_item"
                  :show-text="false"
                ></el-progress>
              </div>
            </div>

            <img
              v-if="item.choice"
              class="iv_choice_photo"
              src="@/assets/images/space/iv_choice_photo.png"
              alt=""
            />
            <img
              v-if="!item.choice && choiceClick == 1 && item.isUpdate == 3"
              class="iv_choice_photo"
              src="@/assets/images/space/iv_choice_can.png"
              alt=""
            />
            <img
              v-if="!item.choice && choiceClick == 1 && item.isUpdate != 3"
              class="iv_choice_photo"
              src="@/assets/images/space/iv_choice_no_can.png"
              alt=""
            />
            <img
              v-if="!item.choice && choiceClick == 2 && item.adminShowDel == 0"
              class="iv_choice_photo"
              src="@/assets/images/space/iv_choice_no_can.png"
              alt=""
            />
            <img
              v-if="
                !item.choice &&
                choiceClick == 2 &&
                (item.isUpdate == 0 || item.isUpdate == 1)
              "
              class="iv_choice_photo"
              src="@/assets/images/space/iv_choice_no_can.png"
              alt=""
            />
            <img
              v-if="
                !item.choice &&
                choiceClick == 2 &&
                item.adminShowDel != 0 &&
                item.isUpdate != 0 &&
                item.isUpdate != 1
              "
              class="iv_choice_photo"
              src="@/assets/images/space/iv_choice_can.png"
              alt=""
            />

            <img
              v-if="i == 0 && choiceClick == 0 && item.isUpdate == 3"
              class="iv_advance_gay"
              src="@/assets/images/space/iv_advance_gay.png"
              alt=""
            />
            <img
              v-if="i != 0 && choiceClick == 0 && item.isUpdate == 3"
              class="iv_advance"
              src="@/assets/images/space/iv_advance_white.png"
              alt=""
              @click.stop="toNext(i)"
            />
            <img
              v-if="
                i == updateFileList.length - 1 &&
                choiceClick == 0 &&
                item.isUpdate == 3
              "
              class="iv_retreat_gay"
              src="@/assets/images/space/iv_retreat_gay.png"
              alt=""
            />
            <img
              v-if="
                i != updateFileList.length - 1 &&
                choiceClick == 0 &&
                item.isUpdate == 3
              "
              class="iv_retreat"
              src="@/assets/images/space/iv_retreat_white.png"
              alt=""
              @click.stop="toLast(i)"
            />
          </div>
          <div
            v-if="item.remark == undefined || item.remark == ''"
            class="v_item_describe_none"
            @click="toAddDescribe('', i, item)"
          >
            暂无描述
          </div>
          <div
            v-if="item.remark != undefined && item.remark != ''"
            class="v_item_describe_have"
            :style="
              choiceClick == 2 && item.adminShowDel == 0
                ? 'color: #949494;'
                : 'color: #000000;'
            "
            @click="toAddDescribe(item.remark, i, item)"
          >
            {{ item.remark }}
          </div>
        </div>
      </draggable>

      <div style="height: 12rem; width: 100%"></div>
    </div>

    <div class="v_bottom_choice" v-if="choiceClick != 0">
      <el-button
        v-if="choiceClick == 1"
        style="
          width: 10rem;
          margin-left: 6rem;
          background: #edf5ff;
          border: 0.1rem solid #edf5ff;
        "
        @click="migrationPhotoCancle()"
        >取消</el-button
      >
      <div v-if="choiceClick == 1" class="v_bottom_choice_text">
        已选择
        <span class="v_bottom_choice_number_blue">{{ choiceNumber }}</span> 项
      </div>
      <el-button
        v-if="choiceClick == 1"
        type="primary"
        style="width: 10rem; margin-right: 5rem"
        @click="migrationPhoto()"
        >确定
      </el-button>

      <el-button
        v-if="choiceClick == 2"
        class="v_bottom_choice_delete_cancle"
        style="width: 10rem; margin-left: 6rem"
        @click="deletePhotoCancle()"
        >取消</el-button
      >
      <div v-if="choiceClick == 2" class="v_bottom_choice_text">
        已选择 <span class="v_bottom_choice_number">{{ choiceNumber }}</span> 项
      </div>
      <el-button
        v-if="choiceClick == 2"
        class="v_bottom_choice_delete"
        style="width: 10rem; margin-right: 5rem"
        @click="deletePhoto()"
        >确定
      </el-button>
    </div>

    <el-dialog
      title="照片/视频描述"
      width="61rem"
      :visible.sync="describeDialog"
      :close-on-click-modal="false"
      :before-close="handleDescribeClose"
    >
      <div class="freezeSpace">
        <div class="cemetery_use_title_b">描述：</div>
        <el-input
          class="search_input_big"
          type="textarea"
          v-model="describe"
          placeholder="请输入照片/视频描述"
          :rows="8"
          maxlength="1000"
          resize="none"
        ></el-input>
        <span class="search_input_big_number_b"
          >{{ describe | describeLength
          }}<span class="search_input_big_number_a">/1000</span></span
        >
      </div>

      <div slot="footer">
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="dialogDescribeSave()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="请选择您要迁移的相册"
      width="70rem"
      :visible.sync="migrationDialog"
      :close-on-click-modal="false"
      :before-close="handleMigrationClose"
      class="move_dialog"
    >
      <div class="v_migration">
        <div
          class="v_migration_item"
          v-for="(item, i) in migrationList"
          :key="i"
          @click="toMigrationChoice(i)"
        >
          <img
            v-if="item.choice"
            class="iv_choice"
            src="@/assets/images/space/iv_choice_yes.png"
            alt=""
          />
          <img
            v-if="!item.choice"
            class="iv_choice"
            src="@/assets/images/space/iv_click_no.png"
            alt=""
          />
          <div class="v_migration_text">{{ item.name }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="dialogMigrationSave()"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixins from "./Mixins";
import axios from "axios";
import draggable from "vuedraggable";
const OSS = require("ali-oss");
import {
  catchErr,
  roundAll,
  nowDate,
  seconds,
  updataLink,
} from "@/utils/utils";
export default {
  components: {
    draggable,
  },
  mixins: [mixins],
  data() {
    return {
      file_list: [],
      keyList: [],
      updateListIndex: 0,
      //选择文件总数
      uploadNum: 0,
      //上传次数
      updateListIndexNew: 0,
      isFirstAddNum: true,

      migrationList: [],
      migrationIndex: -1,
      migrationIds: [],
      migrationIndexs: [],

      migrationDialog: false,
      scrollPhoto: "",
      choiceClick: 0,
      describeDialog: false,
      describe: "",
      describeIndex: -1,
      choiceNumber: 0,
      loadingAll: "",

      //上传成功的照片
      addIds: [],

      // 拖动排序
      arrIdsDragBegin: [],
      arrPhotosDragBegin:[]
    };
  },
  computed: {
    OSSInfo(file) {
      let data = {
        ...this.Common.OSSINFONew,
        fileName: this.Common.FileName,
      };
      this.keyList.push(data);
      return data;
    },
    details() {
      return this.SpaceManagement.spaceDetails.details;
    },
    photoAlbumDetails: {
      get: function () {
        return this.SpaceManagement.spaceDetails.photoAlbumDetails;
      },
      set: function (v) {
        this.PHOTOALBUMDETAILS(v);
      },
    },
    isCanUpdate: {
      get: function () {
        return this.SpaceManagement.spaceDetails.isCanUpdate;
      },
      set: function (v) {
        this.SETCANUPDATE(v);
      },
    },
    //上传数组
    updateFileList: {
      get: function () {
        return this.SpaceManagement.spaceDetails.updateFileList;
      },
      set: function (v) {
        this.UPDATEFILELIST(v);
      },
    },
    uploadState: {
      get: function () {
        return this.SpaceManagement.spaceDetails.uploadState;
      },
      set: function (v) {
        this.SETUPLOAD(v);
      },
    },
    isCanNext: {
      get: function () {
        return this.SpaceManagement.spaceDetails.isCanNext;
      },
      set: function (v) {
        this.ISCANNEXT(v);
      },
    },
    isCanDrag: {
      get: function () {
        if(this.choiceClick != 0 ) {
          return false
        }
        else {
          var result = true;
          for(let a = 0;a < this.updateFileList.length;a ++) {
          var objThis = this.updateFileList[a];
          if(objThis.isUpdate != 3) {
            result = false
          }
          return result
        }
        }
        
        
      },
      set: function (v) {
      },
    },
  },
  filters: {
    describeLength(v) {
      if (v) {
        return v.length;
      } else {
        return 0;
      }
    },
  },
  created() {},
  mounted() {
    this.setLeftMenuShow_M(false);
    this.categoryId = this.photoAlbumDetails.categoryId;
    //获取节点
    this.scrollPhoto = document.getElementById("scrollPhoto");
    //绑定事件
    this.scrollPhoto.addEventListener("scroll", this.handleScroll);
  },
  watch: {},
  methods: {
    // 拖动排序
    handlePhotosOrderChangeStart(e) {
      var arrIds = [];
      this.updateFileList.forEach((item) => {
        arrIds.push(item.id);
      });
      this.arrIdsDragBegin = JSON.parse(JSON.stringify(arrIds));
      this.arrPhotosDragBegin = JSON.parse(JSON.stringify(this.updateFileList));
    },

    handlePhotosOrderChangeEnd(e) {
      var dragFromIndex = e.oldIndex;
      var dragToIndex = e.newIndex;
      
      if ( dragFromIndex != dragToIndex && this.isCanDrag ) {
        var oldPhotoId = this.arrIdsDragBegin[e.oldIndex];
        this.arrIdsDragBegin.splice(e.oldIndex,1);
        var newPhotoId = '';
        if(e.newIndex > 0 && e.newIndex <= this.arrIdsDragBegin.length) { 
          newPhotoId = this.arrIdsDragBegin[e.newIndex - 1];
        }
        let params = {
          categoryId: this.categoryId,
          photoId: oldPhotoId,
          targetPhotoId: newPhotoId,
        };
        this.dragPhoto(
          params
        ).then((res) => {
          console.log(res);
          if (res.status == 1000) {
            this.$message.success("操作成功");
          } else if(res.status == 1008) {
            // 操作频繁
            this.updateFileList = this.arrPhotosDragBegin;
          } else {
            this.$message.error("操作失败，请刷新后重新操作");
            this.updateFileList = this.arrPhotosDragBegin;
          }
        });
      }

    },

    handFileChange(files, fileList) {
      if (this.isFirstAddNum) {
        this.isFirstAddNum = false;
        var upload_img = document.getElementsByClassName("upLoadVideo_all");
        this.uploadNum = 0;
        if (upload_img && upload_img.length > 0) {
          var upload = upload_img[0].getElementsByTagName("input");
          if (
            upload &&
            upload.length > 0 &&
            upload[0].files &&
            upload[0].files.length > 0
          ) {
            this.uploadNum = upload[0].files.length;
          }
        }
        if (this.uploadNum == 0) {
          this.isFirstAddNum = true;
          this.$refs.upLoad.clearFiles();
        }
      }
    },
    beforeAvatarUpload(file) {
      console.log(file);
      this.updateListIndexNew = this.updateListIndexNew + 1;
      if (file.type == "video/mp4") {
        let arrList = file.name.split(".");
        let nameEnd = arrList[arrList.length - 1].toUpperCase();
        console.log(nameEnd);
        if (nameEnd != "MP4") {
          this.$message.error(
            "上传照片格式限制为jpg或png,上传视频格式限制为mp4"
          );
          if (this.uploadNum == this.updateListIndexNew) {
            this.updateListIndexNew = 0;
            this.updateListIndex = 0;
            this.isFirstAddNum = true;
          }
          return false;
        }
        const isVideoSize =
          file.size / 1024 >= 1024 * 1 && file.size / 1024 <= 1024 * 300;
        if (!isVideoSize) {
          this.$message.error("上传视频大小限制为1~300MB");
          if (this.uploadNum == this.updateListIndexNew) {
            this.updateListIndexNew = 0;
            this.updateListIndex = 0;
            this.isFirstAddNum = true;
          }
          return false;
        }
        //纪念堂大小判断
        let fileBig =
          this.SpaceManagement.spaceDetails.details.fileSizeUse +
          file.size / 1024;
        if (fileBig > this.SpaceManagement.spaceDetails.details.fileSizeCount) {
          this.$message.error("文件大小超出纪念堂剩余大小，请重新选择文件");
          if (this.uploadNum == this.updateListIndexNew) {
            this.updateListIndexNew = 0;
            this.updateListIndex = 0;
            this.isFirstAddNum = true;
          }
          return false;
        } else {
          this.SpaceManagement.spaceDetails.details.fileSizeUse = fileBig;
        }
        this.updateListIndex = this.updateListIndex + 1;
        var url = URL.createObjectURL(file);
        var audioElement = new Audio(url);
        var self = this;
        var resultTime;
        var timestamp = new Date().getTime();
        for (var i = 0; i < 6; i++) {
          timestamp = timestamp + "" + Math.floor(Math.random() * 10);
        }
        let arr = file.name.split(".");
        timestamp = timestamp + "." + arr[arr.length - 1];
        let size = file.size / 1024;
        let fileChild = {
          name: file.name,
          nameNew: timestamp,
          size: parseInt(size),
          url: "",
          wh: "",
          percent: 0,
          type: 2,
          isUpdate: 9, //0上传中，1成功，2失败，3隐藏所有, 4文件大小超出, 5文件改变, 6无主办人, 7授权失效, 8继续上传
          file: file,
          remark: "",
        };
        fileChild.photoUrl = URL.createObjectURL(file);
        audioElement.addEventListener("loadedmetadata", function () {
          // 视频时长值的获取要等到这个匿名函数执行完毕才产生
          resultTime = audioElement.duration; //得到时长为秒，小数，182.36
          fileChild.intResult = Math.round(resultTime);
          fileChild.seconds = seconds.getSecond(Math.round(resultTime));
        });
        //self.updateFileList.push(fileChild);
        self.updateFileList.splice(self.updateListIndex - 1, 0, fileChild);
      } else if (file.type == "image/jpeg" || file.type == "image/png") {
        const isImageSize = file.size / 1024 <= 1024 * 20;
        if (!isImageSize) {
          this.$message.error("照片大小已超出20MB");
          console.log(this.uploadNum);
          console.log(this.updateListIndexNew);
          if (this.uploadNum == this.updateListIndexNew) {
            this.updateListIndexNew = 0;
            this.updateListIndex = 0;
            this.isFirstAddNum = true;
          }
          return false;
        }
        //纪念堂大小判断
        let fileBig =
          this.SpaceManagement.spaceDetails.details.fileSizeUse +
          file.size / 1024;
        if (fileBig > this.SpaceManagement.spaceDetails.details.fileSizeCount) {
          this.$message.error("文件大小超出纪念堂剩余大小，请重新选择文件");
          if (this.uploadNum == this.updateListIndexNew) {
            this.updateListIndexNew = 0;
            this.updateListIndex = 0;
            this.isFirstAddNum = true;
          }
          return false;
        } else {
          this.SpaceManagement.spaceDetails.details.fileSizeUse = fileBig;
        }
        this.updateListIndex = this.updateListIndex + 1;
        var timestamp = new Date().getTime();
        for (var i = 0; i < 6; i++) {
          timestamp = timestamp + "" + Math.floor(Math.random() * 10);
        }
        let arr = file.name.split(".");
        timestamp = timestamp + "." + arr[arr.length - 1];
        let size = file.size / 1024;
        let fileChild = {
          name: file.name,
          nameNew: timestamp,
          size: parseInt(size),
          url: "",
          wh: "",
          percent: 0,
          type: 1,
          isUpdate: 9,
          file: file,
          remark: "",
        };
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function () {
          fileChild.photoUrl = this.result;
        };
        //this.updateFileList.push(fileChild);
        this.updateFileList.splice(this.updateListIndex - 1, 0, fileChild);
      } else {
        if (this.uploadNum == this.updateListIndexNew) {
          this.updateListIndexNew = 0;
          this.updateListIndex = 0;
          this.isFirstAddNum = true;
        }
        this.$message.error("上传照片格式限制为jpg或png,上传视频格式限制为mp4");
        return false;
      }
      return new Promise((resolve, reject) => {
        let createTime = this.getFullTime(10 - (this.updateListIndex - 1));

        //获取签名
        this.getDataa(
          timestamp,
          this.updateListIndex,
          createTime,
          this.updateFileList[this.updateListIndex - 1]
        )
          .then((res) => {
            if (res) {
              resolve(true);
            } else {
              reject(false);
              //this.updateFileList[this.updateListIndex - 1].isUpdate = 2;
              this.updateFileList.forEach((k) => {
                if (k.nameNew == timestamp) {
                  k.isUpdate = 2;
                }
              });
            }
            console.log(this.uploadNum);
            console.log(this.updateListIndexNew);
            if (this.uploadNum == this.updateListIndexNew) {
              this.updateListIndexNew = 0;
              this.updateListIndex = 0;
              this.isFirstAddNum = true;
            }
          })
          .catch((err) => {
            reject(false);
            //this.updateFileList[this.updateListIndex - 1].isUpdate = 2;
            this.updateFileList.forEach((k) => {
              if (k.nameNew == timestamp) {
                k.isUpdate = 2;
              }
            });
            if (this.fileListChoice.length == this.updateListIndexNew) {
              this.updateListIndexNew = 0;
              this.updateListIndex = 0;
            }
          });
      });
    },
    getFullTime(index = 0) {
      let newDate = new Date();
      let date = new Date(newDate.getTime() + index * 1000);

      let Y = date.getFullYear() + "",
        M =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1,
        D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
        h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        m =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
        s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
    },
    async getDataa(timestamp, index, createTime, item) {
      let params = {
        timestamp: timestamp,
        path: "deadMan",
        index: index,
        createTime: createTime,
        item: item,
      };
      return await this.getOSSsignature(params);
    },
    // 自定义文件上传的模式，方法
    async myFileUpload(params) {
      params.data.itemNow.isUpdate = 0;
      console.log(params);
      //let createTime = this.getFullTime(10 - (params.data.index - 1));
      let createTime = params.data.createTime;
      let tempstampThis = params.data.currTimestamp - (params.data.index - 1);
      let data = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        type: "TYPE_UPLOAD_STATE_FAIL",
        title: params.file.name,
      };
      this.saveLog(data).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          let client = new OSS({
            region: params.data.region,
            accessKeyId: params.data.accessKeyId,
            accessKeySecret: params.data.accessKeySecret,
            stsToken: params.data.securityToken,
            bucket: params.data.bucket,
            endpoint: params.data.endpoint,
            cname: params.data.cname,
          });

          let that = this;

          console.log(this.updateFileList);

          async function multipartUpload() {
            try {
              const result = await client.multipartUpload(
                `${updataLink()}space/${
                  that.SpaceManagement.spaceDetails.details.id
                }/yesterday/sye_server_` + params.data.fileName,
                params.file,
                {
                  progress: function (p, checkpoint) {
                    params.data.itemNow.tempCheckpoint = checkpoint;
                    params.data.itemNow.percent = parseInt(
                      (p * 100).toFixed(0)
                    );
                    params.data.itemNow.updateId = res.data;
                  },
                  partSize: 1024 * 1024,
                }
              );
              console.log(result);
              that.toDiySuccessEnd(
                result,
                params.data.index - 1,
                tempstampThis,
                createTime,
                params.data.itemNow
              );
            } catch (e) {
              console.log(e);
              if (e.name == "NotFoundError") {
                params.data.itemNow.isUpdate = 5;
                params.data.itemNow.updateId = res.data;
                params.data.itemNow.createTime = createTime;
                params.data.itemNow.createTimestamp = tempstampThis;
              } else {
                params.data.itemNow.isUpdate = 8;
                params.data.itemNow.updateId = res.data;
                params.data.itemNow.createTime = createTime;
                params.data.itemNow.createTimestamp = tempstampThis;
              }
            }
          }

          // 开始分片上传。
          multipartUpload();
        } else {
          if (res.status == 1098) {
            this.showCo();
          }
          this.updateFileList[params.data.index - 1].isUpdate = 2;
        }
      });
    },
    toDiySuccessEnd(result, index, tempstampThis, createTime, k) {
      k.createTime = createTime;
      k.createTimestamp = tempstampThis;
      if (
        k.nameNew ==
        result.name.replace(
          `${updataLink()}space/${
            this.SpaceManagement.spaceDetails.details.id
          }/yesterday/sye_server_`,
          ""
        )
      ) {
        k.url = "https://zgsm.zhongguangshimei.com/" + result.name;

        let item = {};

        item.categoryId = this.categoryId;
        item.title = k.name;
        item.photoUrl = k.url;
        item.type = k.type;
        item.source = 3;
        item.no = "";
        item.wh = "";
        item.size = k.size;
        item.isDel = "0";
        item.createTime = createTime;
        item.createTimestamp = tempstampThis;
        if (k.type == 2) {
          item.second = k.intResult;
        }

        let params = {};
        params.id = this.SpaceManagement.spaceDetails.details.id;
        params.logId = k.updateId;
        params.undertakerId =
          this.SpaceManagement.spaceDetails.details.undertakerId;
        params.photoList = [];
        params.photoList.push(item);

        //照片-上传相册照片
        this.addPhotoByCategoryIdHttp(params, k);
      }
    },
    onEexceed(files, fileList) {
      this.$message.error("一次最多上传十个文件");
    },
    handleAvatarSuccess(res, file, fileList) {
      return;
    },
    uploadVideoProcess(event, file, fileList) {},
    handleAvatarError(res, file, fileList) {
      console.log(res);
    },
    toUpdateAgain(index, item) {
      item.isUpdate = 0;
      item.percent = 0;
      let params = {
        path: "deadMan",
      };
      this.getDatab(params).then((res) => {
        console.log(res);
        if (!res) {
          item.isUpdate = 2;
          return;
        }

        if (item.updateId != undefined) {
          this.toUpdateAgainAgain(index, res, item);
        } else {
          let data = {
            dmId: this.SpaceManagement.spaceDetails.details.id,
            type: "TYPE_UPLOAD_STATE_FAIL",
            title: item.name,
          };
          this.saveLog(data).then((resb) => {
            if (resb.status == 1000) {
              item.updateId = resb.data;
              this.toUpdateAgainAgain(index, res, item);
            } else if (resb.status == 1061) {
              item.isUpdate = 4;
            } else {
              if (res.status == 1098) {
                this.showCo();
              }
              item.isUpdate = 2;
            }
          });
        }
      });
    },
    toUpdateAgainAgain(index, res, itemAgain) {
      let client = new OSS({
        region: res.data.region,
        accessKeyId: res.data.accessKeyId,
        accessKeySecret: res.data.accessKeySecret,
        stsToken: res.data.securityToken,
        bucket: res.data.bucket,
        endpoint: res.data.endpoint,
        cname: res.data.cname,
      });

      let that = this;

      async function multipartUpload() {
        try {
          const result = await client.multipartUpload(
            `${updataLink()}space/${
              that.SpaceManagement.spaceDetails.details.id
            }/yesterday/sye_server_` + itemAgain.nameNew,
            itemAgain.file,
            {
              progress: function (p, checkpoint) {
                itemAgain.tempCheckpoint = checkpoint;
                itemAgain.percent = parseInt((p * 100).toFixed(0));
              },
              partSize: 1024 * 1024,
            }
          );
          console.log(result);

          itemAgain.url = "https://zgsm.zhongguangshimei.com/" + result.name;

          let item = {};
          item.title = itemAgain.name;
          item.photoUrl = itemAgain.url;
          item.type = itemAgain.type;
          item.source = 3;
          item.no = "";
          item.wh = "";
          item.size = itemAgain.size;
          if (itemAgain.type == 2) {
            item.second = itemAgain.intResult;
          }
          item.categoryId = that.categoryId;
          item.isDel = "0";
          item.createTime = itemAgain.createTime;
          item.createTimestamp = itemAgain.createTimestamp;

          let params = {};
          params.id = that.SpaceManagement.spaceDetails.details.id;
          params.logId = itemAgain.updateId;
          params.undertakerId =
            that.SpaceManagement.spaceDetails.details.undertakerId;
          params.photoList = [];
          params.photoList.push(item);

          //照片-上传相册照片
          that.addPhotoByCategoryIdHttp(params, itemAgain);
        } catch (e) {
          console.log(e);
          if (e.name == "NotFoundError") {
            itemAgain.isUpdate = 5;
          } else {
            itemAgain.isUpdate = 2;
          }
        }
      }

      // 开始分片上传。
      multipartUpload();
    },
    toUpdateContinue(index, item) {
      item.isUpdate = 0;
      let params = {
        path: "deadMan",
      };
      this.getDatab(params).then((res) => {
        console.log(res);
        if (!res) {
          item.isUpdate = 8;
          return;
        }

        let resumeclient = new OSS({
          region: res.data.region,
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
          stsToken: res.data.securityToken,
          bucket: res.data.bucket,
          endpoint: res.data.endpoint,
          cname: res.data.cname,
        });

        let that = this;

        async function resumeUpload() {
          try {
            const result = await resumeclient.multipartUpload(
              `${updataLink()}space/${
                that.SpaceManagement.spaceDetails.details.id
              }/yesterday/sye_server_` + item.nameNew,
              item.file,
              {
                progress: function (p, checkpoint) {
                  item.tempCheckpoint = checkpoint;
                  item.percent = parseInt((p * 100).toFixed(0));
                },
                checkpoint: item.tempCheckpoint,
              }
            );

            console.log(result);

            that.toContinueNext(result, index, item);
          } catch (e) {
            console.log(e);
            if (e.name == "NotFoundError") {
              item.isUpdate = 5;
            } else {
              item.isUpdate = 8;
            }
          }
        }

        resumeUpload();
      });
    },
    toContinueNext(result, index, itemAgain) {
      let that = this;
      itemAgain.url = "https://zgsm.zhongguangshimei.com/" + result.name;

      let item = {};
      item.title = itemAgain.name;
      item.photoUrl = itemAgain.url;
      item.type = itemAgain.type;
      item.source = 3;
      item.no = "";
      item.wh = "";
      item.size = itemAgain.size;
      if (itemAgain.type == 2) {
        item.second = itemAgain.intResult;
      }
      item.categoryId = that.categoryId;
      item.isDel = "0";
      item.createTime = itemAgain.createTime;
      item.createTimestamp = itemAgain.createTimestamp;

      let params = {};
      params.id = that.SpaceManagement.spaceDetails.details.id;
      params.logId = itemAgain.updateId;
      params.undertakerId =
        that.SpaceManagement.spaceDetails.details.undertakerId;
      params.photoList = [];
      params.photoList.push(item);

      //照片-上传相册照片
      that.addPhotoByCategoryIdHttp(params, itemAgain);
    },
    async getDatab() {
      return await this.getOSSsignatureAgain("deadMan");
    },

    addPhotoByCategoryIdHttp(params, item) {
      let that = this;
      //照片-上传相册照片
      // if (!that.isCanUpdate) {
      //   return
      // }
      that.addPhotoByCategoryId(params).then((res) => {
        console.log(res);
        //that.editUploadById(params).then((res) => {
        if (res.status == 1000) {
          that.addIds.push(res.data);
          item.id = res.data;
          item.photoUrl = item.url;
          item.dmId = that.SpaceManagement.spaceDetails.details.id;
          setTimeout(() => {
            item.isUpdate = 1;
            setTimeout(() => {
              item.isUpdate = 3;
            }, 1000);
          }, 1000);
        } else if (res.status == 1061) {
          //失败
          item.isUpdate = 4;
        } else if (res.status == 1066) {
          //失败
          item.isUpdate = 6;
        } else if (res.status == 1086) {
          //失败
          item.isUpdate = 7;
        } else {
          //失败
          if (res.status == 1098) {
            that.showCo();
          }
          item.isUpdate = 2;
        }
      });
    },

    //删除
    deletePhoto() {
      let ids = [];
      let indexs = [];
      this.updateFileList.forEach((item, index) => {
        if (item.choice) {
          if (item.id != undefined) {
            ids.push(item.id);
          }
          indexs.push(index);
        }
      });
      if (indexs.length < 1) {
        this.$message.error("请选择照片/视频");
        return;
      }
      if (indexs.length > 50) {
        this.$message.error("您已超过单次删除最高上限50个");
        return;
      }
      this.$confirm("确定删除所选照片/视频吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (ids.length == 0) {
            this.$message.success("操作成功");
            for (let a = indexs.length - 1; a >= 0; a--) {
              this.updateFileList.splice(indexs[a], 1);
            }
            this.choiceNumber = 0;
            return;
          }
          let params = {
            dmId: this.SpaceManagement.spaceDetails.details.id,
            categoryId: this.photoAlbumDetails.categoryId,
            ids: ids,
          };
          this.delPhotoById(params).then((res) => {
            console.log(res);
            if (res.status == 1000) {
              this.$message.success("操作成功");
              for (let a = indexs.length - 1; a >= 0; a--) {
                this.updateFileList.splice(indexs[a], 1);
              }
              // 删除上传照片
              for (let i = 0; i < ids.length; i++) {
                for (let j = this.addIds.length - 1; j > 0; j--) {
                  if (this.addIds[j] === ids[i]) {
                    this.addIds.splice(j, 1);
                    j--;
                  }
                }
              }
              this.choiceNumber = 0;
              if (this.updateFileList.length < 50) {
                //加载更多
                this.toAddMore();
              } else {
              }
            } else if (res.status == 1098) {
              this.showCo();
            }
          });
        })
        .catch(() => {});
    },

    deletePhotoCancle() {
      this.choiceNumber = 0;
      this.updateFileList.forEach((item) => {
        item.choice = false;
      });
      this.choiceClick = 0;
    },

    migrationPhotoCancle() {
      this.choiceNumber = 0;
      this.updateFileList.forEach((item) => {
        item.choice = false;
      });
      this.choiceClick = 0;
    },

    //迁移
    migrationPhoto() {
      this.migrationIds = [];
      this.migrationIndexs = [];
      this.updateFileList.forEach((item, index) => {
        if (item.choice) {
          this.migrationIds.push(item.id);
          this.migrationIndexs.push(index);
        }
      });
      if (this.migrationIds.length < 1) {
        this.$message.error("请选择照片/视频");
        return;
      }
      let params = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        categoryId: this.photoAlbumDetails.categoryId,
      };
      this.findMovePhotoCategory(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          if (res.data.length > 0) {
            this.migrationDialog = true;
            res.data.forEach((item) => {
              item.choice = false;
            });
            this.migrationList = res.data;
          } else {
            this.$message.error("暂无其他相册可以迁移");
          }
        } else if (res.status == 1098) {
          this.showCo();
        }
      });
    },
    toMigrationChoice(index) {
      this.migrationIndex = index;
      this.migrationList.forEach((item, i) => {
        if (i == index) {
          item.choice = true;
        } else {
          item.choice = false;
        }
      });
    },
    dialogMigrationSave() {
      if (this.migrationIndex == -1) {
        this.$message.error("请选择您要迁移的相册");
        return;
      }
      let htmlStr = `<div>确定要迁移到<span style='color:#4EA2FF;font-size:2rem;'> ${
        this.migrationList[this.migrationIndex].name
      } </span>相册吗？</div>`;
      this.$Confirm(htmlStr, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          let params = {
            dmId: this.SpaceManagement.spaceDetails.details.id,
            categoryId: this.migrationList[this.migrationIndex].id,
            ids: this.migrationIds,
          };
          this.movePhoto(params).then((res) => {
            console.log(res);
            if (res.status == 1000) {
              this.$message.success("操作成功");
              for (let a = this.migrationIndexs.length - 1; a >= 0; a--) {
                this.updateFileList.splice(this.migrationIndexs[a], 1);
              }
              // 迁移上传照片
              for (let i = 0; i < this.migrationIndexs.length; i++) {
                for (let j = this.addIds.length - 1; j > 0; j--) {
                  if (this.addIds[j] === this.migrationIndexs[i]) {
                    this.addIds.splice(j, 1);
                    j--;
                  }
                }
              }
              if (this.updateFileList.length < 50) {
                //加载更多
                this.toAddMore();
              } else {
              }
              this.migrationList = [];
              this.migrationIndex = -1;
              this.migrationDialog = false;
              this.choiceNumber = 0;
            } else if (res.status == 1098) {
              this.showCo();
            }
          });
        })
        .catch(() => {});
    },
    handleMigrationClose(done) {
      this.migrationList = [];
      this.migrationIndex = -1;
      done();
    },
    //滚动事件的监听处理
    handleScroll() {
      const that = this;
      if (
        this.scrollPhoto.scrollHeight <=
        this.scrollPhoto.scrollTop + this.scrollPhoto.offsetHeight
      ) {
        console.log("到底了");
        //加载更多
        this.toAddMore();
      }
    },
    toAddMore() {
      if (this.isCanNext) {
        this.isCanNext = false;
        let that = this;
        //setTimeout(function () {
        let params = {};
        params.data = {
          dmId: that.SpaceManagement.spaceDetails.details.id,
          categoryId: that.photoAlbumDetails.categoryId,
        };
        that.pageInfo = {
          page: 1,
          size: 50,
          total: 0,
        };
        params.pageInfo = that.pageInfo;
        if (that.updateFileList.length > 0) {
          params.data.lastPhotoId =
            that.updateFileList[that.updateFileList.length - 1].id;
          params.data.lastCreateTimestamp =
            that.updateFileList[that.updateFileList.length - 1].createTimestamp;
        }
        if (that.addIds.length != 0) {
          params.data.filterIds = that.addIds;
        }
        that.findPhotoByCategoryId(params).then((res) => {
          console.log(res);
          if (res.status == 1000) {
            if (res.data.length < 50) {
              that.isCanNext = false;
            } else {
              that.isCanNext = true;
            }
            res.data.forEach((item) => {
              item.isUpdate = 3;
              if (item.type == 2) {
                item.seconds = seconds.getSecond(Math.round(item.second));
              }
            });
            res.data.forEach((item) => {
              item.isUpdate = 3;
              if (item.type == 2) {
                item.seconds = seconds.getSecond(Math.round(item.second));
              }
            });
            that.updateFileList = that.updateFileList.concat(res.data);
          } else if (res.status == 1098) {
            that.isCanNext = true;
            that.showCo();
          }
        });
        //}, 2000)
      }
    },
    toChoicePhoto(index) {
      if (this.choiceClick != 0) {
        if (
          this.choiceClick == 2 &&
          this.updateFileList[index].adminShowDel == 0
        ) {
          this.$message.error("历史数据不能进行删除操作");
          return;
        }
        if (
          this.choiceClick == 2 &&
          (this.updateFileList[index].isUpdate == 0 ||
            this.updateFileList[index].isUpdate == 1)
        ) {
          this.$message.error("正在上传数据不能进行删除操作");
          return;
        }
        if (this.choiceClick == 1 && this.updateFileList[index].isUpdate != 3) {
          this.$message.error("未上传成功数据不能进行迁移操作");
          return;
        }
        if (this.choiceClick == 2 && this.choiceNumber == 50) {
          if (this.updateFileList[index].choice) {
            this.updateFileList[index].choice = false;
            this.choiceNumber--;
          } else {
            this.$message.error("您已超过单次删除最高上限50个");
          }
          return;
        } else {
          this.updateFileList[index].choice =
            !this.updateFileList[index].choice;
          if (this.updateFileList[index].choice) {
            this.choiceNumber++;
          } else {
            this.choiceNumber--;
          }
        }
      }
    },
    //选择删除
    choicePhotoDelete() {
      this.choiceClick = 2;
    },
    //选择迁移
    choicePhotoMove() {
      this.choiceClick = 1;
    },
    toNext(index) {
      let number = "";
      for (let i = index - 1; i >= 0; i--) {
        if (this.updateFileList[i].id != undefined) {
          number = i;
          break;
        }
      }
      if (number === "") {
        this.$message.error("不能左移");
        return;
      }
      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        categoryId: this.photoAlbumDetails.categoryId,
        currentPhotoId: this.updateFileList[index].id,
        targetPhotoId: this.updateFileList[number].id,
      };
      if (index == 1) {
        params.targetPhotoFirst = 1;
      }
      this.editPhotoPosition(params).then((res) => {
        console.log(res);
        this.loadingAll.close();
        if (res.status == 1000) {
          this.$message.success("操作成功");
          this.updateFileList[index] = this.updateFileList.splice(
            number,
            1,
            this.updateFileList[index]
          )[0];
        } else if (res.status == 1098) {
          this.showCo();
        }
      });
    },
    toLast(index) {
      let number = "";
      for (let i = index + 1; i < this.updateFileList.length; i++) {
        if (this.updateFileList[i].id != undefined) {
          number = i;
          break;
        }
      }
      if (number === "") {
        this.$message.error("不能右移");
        return;
      }
      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        categoryId: this.photoAlbumDetails.categoryId,
        currentPhotoId: this.updateFileList[index].id,
        targetPhotoId: this.updateFileList[number].id,
      };
      if (index == 0) {
        params.targetPhotoFirst = 1;
      }
      this.editPhotoPosition(params).then((res) => {
        console.log(res);
        this.loadingAll.close();
        if (res.status == 1000) {
          this.$message.success("操作成功");
          this.updateFileList[index] = this.updateFileList.splice(
            number,
            1,
            this.updateFileList[index]
          )[0];
        } else if (res.status == 1098) {
          this.showCo();
        }
      });
    },
    //添加修改描述
    toAddDescribe(describe, index, item) {
      if (this.choiceClick == 0) {
        if (item.isUpdate != 3) {
          this.$message.error("没有上传成功的图片/视频不能添加描述");
          return;
        }
        this.describe = describe.replace(/(^\s*)|(\s*$)/g, "");
        this.describeIndex = index;
        this.describeDialog = true;
      } else {
        if (this.choiceClick == 2 && item.adminShowDel == 0) {
          this.$message.error("历史数据不能进行删除操作");
          return;
        }
        if (
          this.choiceClick == 2 &&
          (item.isUpdate == 0 || item.isUpdate == 1)
        ) {
          this.$message.error("正在上传的图片/视频不能进行删除操作");
          return;
        }
        if (this.choiceClick == 1 && item.isUpdate != 3) {
          this.$message.error("没有上传成功的图片/视频不能进行迁移操作");
          return;
        }
        item.choice = !item.choice;
        if (item.choice) {
          this.choiceNumber++;
        } else {
          this.choiceNumber--;
        }
      }
    },
    handleDescribeClose(done) {
      this.describe = "";
      this.describeIndex = -1;
      done();
    },
    dialogDescribeSave() {
      let params = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
        id: this.updateFileList[this.describeIndex].id,
        remark: this.describe,
      };
      this.editPhotoRemark(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("操作成功");
          this.updateFileList[this.describeIndex].remark = this.describe;
          this.describe = "";
          this.describeIndex = -1;
          this.describeDialog = false;
        } else if (res.status == 1098) {
          this.showCo();
        }
      });
    },
    closePhoto() {
      this.scrollPhoto.scrollTop = 0;
      this.isCanUpdate = false;
      this.choiceClick = 0;
      this.choiceNumber = 0;
      this.updateFileList.forEach((item, index) => {
        item.choice = false;
      });
      this.photoAlbumDetails = {
        show: false,
        name: "",
        categoryId: "",
      };
      this.updateFileList = [];

      this.findPhotoCategory(this.SpaceManagement.spaceDetails.details.id);

      this.findByIdAnother(this.SpaceManagement.spaceDetails.details.id).then(
        (res) => {
          if (res.status == 1000) {
            if (res.data.fileVideoSizeUse == 0) {
              this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = 0;
            } else {
              this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef =
                (res.data.fileVideoSizeUse / res.data.fileSizeCount) * 100;
              if (
                this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef < 1
              ) {
                this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = 1;
              }
            }
            if (res.data.filePicSizeUse == 0) {
              this.SpaceManagement.spaceDetails.details.filePicSizeUsef = 0;
            } else {
              this.SpaceManagement.spaceDetails.details.filePicSizeUsef =
                (res.data.filePicSizeUse / res.data.fileSizeCount) * 100;
              if (
                this.SpaceManagement.spaceDetails.details.filePicSizeUsef < 1
              ) {
                this.SpaceManagement.spaceDetails.details.filePicSizeUsef = 1;
              }
            }

            this.SpaceManagement.spaceDetails.details.fileSizeUse =
              res.data.fileSizeUse;
            this.SpaceManagement.spaceDetails.details.fileSizeCount =
              res.data.fileSizeCount;
            this.SpaceManagement.spaceDetails.details.fileSizeUseA =
              roundAll.roundFn(res.data.fileSizeUse / 1024 / 1024, 3);
            this.SpaceManagement.spaceDetails.details.fileSizeCountA =
              roundAll.roundFn(
                res.data.fileSizeCount / 1024 / 1024 -
                  res.data.fileSizeUse / 1024 / 1024,
                3
              );

            this.SpaceManagement.spaceDetails.details.fileVideoCount =
              res.data.fileVideoCount;
            this.SpaceManagement.spaceDetails.details.filePicCount =
              res.data.filePicCount;
            this.SpaceManagement.spaceDetails.details.viewCount =
              res.data.viewCount;

            if (res.data.uploadState == 1) {
              this.uploadState = false;
            } else {
              this.uploadState = true;
            }
            this.SpaceManagement.spaceDetails.details.claimState =
              res.data.claimState;
          } else if (res.status == 1098) {
            this.showCo();
          }
        }
      );
    },
    showCo() {
      this.$Confirm("纪念堂已失效，请返回纪念堂列表页面刷新", "提示", {
        type: "warning",
        showCancelButton: false,
      })
        .then(() => {
          window.opener = null;
          window.open("about:blank", "_top").close();
        })
        .catch(() => {
          window.opener = null;
          window.open("about:blank", "_top").close();
        });
    },
  },
  //移除滚动条监听
  destroyed() {
    this.scrollPhoto.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="stylus" scoped>
.v_space_photo_backgound {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  .v_space_photo_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 108px;
    line-height: 108px;

    .v_space_photo_title_text {
      margin-left: 60px;
      font-size: 34px;
      font-weight: 500;
      color: #000000;
    }

    .v_space_photo_title_name {
      color: #2C90FF;
    }

    .iv_close {
      margin-right: 50px;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }

  .v_space_photo_button {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  .v_space_photo_list_none {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    bottom: 0;
    top: 158px;
    font-weight: 400;
    color: #949494;
    font-size: 20px;
  }

  .v_space_photo_list {
    padding-left: 30px;
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    bottom: 0;
    top: 158px;
    overflow: auto;
    box-sizing: border-box;

    .v_draggable_area {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: flex-start;
      width: 100%;
    }

    .v_space_photo_list_item {
      margin-top: 20px;
      height: 240px;

      .v_item_all {
        width: 200px;
        height: 200px;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
      }

      .update_item_img_all {
        cursor: pointer;
      }

      .update_item_img_all_img {
        width: 200px;
        height: 200px;
        // border-radius: 10px;
        overflow: hidden;
        object-fit: cover;
      }

      .update_item_img_all_img_video {
        width: 200px;
        height: 200px;
        // border-radius: 10px;
        overflow: hidden;
        object-fit: cover;
      }

      .update_item_img_all_img_seconds {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
        color: #ffffff;
        background: rgba(0, 0, 0, 0.2);
        // border-radius: 10px;
        font-size: 20px;
      }

      .update_item_img_all_gray {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 200px;
        height: 200px;
        // border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.4);
      }

      .update_item_img_all_img_suc {
        width: 34px;
        height: 34px;
      }

      .update_item_img_all_img_fai {
        width: 64px;
        height: 71px;
      }

      .video_progress_item {
        width: 180px;
        position: absolute;
        left: 10px;
        bottom: 10px;
      }

      .iv_item {
        width: 200px;
        height: 200px;
        background-color: #2C90FF;
      }

      .iv_choice_photo {
        width: 34px;
        height: 34px;
        position: absolute;
        top: 10px;
        right: 10px;
      }

      .iv_advance {
        width: 15px;
        height: 28px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 6px;
        background-color: rgba(0, 0, 0, 0.2);
        position: absolute;
        bottom: 0;
        left: 0;
        cursor: pointer;
      }

      .iv_advance_gay {
        width: 15px;
        height: 28px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 6px;
        background-color: rgba(0, 0, 0, 0.2);
        position: absolute;
        bottom: 0;
        left: 0;
        cursor: not-allowed;
      }

      .iv_retreat {
        width: 15px;
        height: 28px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 6px;
        background-color: rgba(0, 0, 0, 0.2);
        position: absolute;
        bottom: 0;
        right: 0;
        cursor: pointer;
      }

      .iv_retreat_gay {
        width: 15px;
        height: 28px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 6px;
        background-color: rgba(0, 0, 0, 0.2);
        position: absolute;
        bottom: 0;
        right: 0;
        cursor: not-allowed;
      }

      .v_item_describe_none {
        margin-left: 10px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #949494;
        cursor: pointer;
      }

      .v_item_describe_have {
        margin-left: 10px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        cursor: pointer;
        width: 160px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .freezeSpace {
    margin-bottom: 30px;
    display: flex;
    position: relative;
    justify-content: center;
  }

  .cemetery_use_title_b {
    width: 50px;
  }

  .search_input_big {
    width: 500px;
    position: relative;
  }

  .search_input_big_number_b {
    position: absolute;
    right: 20px;
    bottom: 8px;
    color: #2C90FF;
    font-size: 14px;
    background: #fff;
  }

  .search_input_big_number_a {
    color: #000000;
    font-size: 14px;
  }

  .search_input_big >>> .el-textarea__inner {
    font-family: 'Microsoft Yahei', '微软雅黑', Arial, sans-serif;
    color: #000000;
  }

  .v_bottom_choice {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 110px;
    line-height: 110px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    box-shadow: -11px 2px 20px 0px rgba(127, 127, 127, 0.2);

    .v_bottom_choice_delete {
      background: #FF4A24;
      color: #ffffff;
      border: 0.1rem solid #FF4A24;
    }

    .v_bottom_choice_delete_cancle {
      background: #FFDED7;
      border: 0.1rem solid #FFDED7;
      color: #FF4A24;
    }

    .v_bottom_choice_text {
      font-size: 18px;
      font-weight: 500;
      color: #000000;
    }

    .v_bottom_choice_number {
      color: #FF4A24;
    }

    .v_bottom_choice_number_blue {
      color: #2C90FF;
    }
  }

  .v_migration {
    padding-top: 15px;
    padding-bottom: 15px;
    max-height: 300px;
    overflow: auto;

    .v_migration_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
    }

    .iv_choice {
      margin-left: 270px;
      width: 17px;
      height: 17px;
    }

    .v_migration_text {
      margin-left: 10px;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
    }
  }
}
</style>

<style>
.move_dialog .el-dialog__body {
  padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartII/SpaceDetails/components/SpacePhoto.vue